/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Catalogue_TitleInputs */

const en_us2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises`)
};

const pt_br2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios`)
};

const es_419_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios`)
};

const pt_pt2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios`)
};

const fr_fr2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices`)
};

const de_de2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen`)
};

const it_it2_exercise_catalogue_title = /** @type {(inputs: Exercise_Catalogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi`)
};

/**
* | output |
* | --- |
* | "Exercises" |
*
* @param {Exercise_Catalogue_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_catalogue_title = /** @type {((inputs?: Exercise_Catalogue_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Catalogue_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_catalogue_title(inputs)
	if (locale === "es-419") return es_419_exercise_catalogue_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_catalogue_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_catalogue_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_catalogue_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_catalogue_title(inputs)
	return en_us2_exercise_catalogue_title(inputs)
});
export { exercise_catalogue_title as "exercise.catalogue_title" }